function RevealStatistics()
{
    const observerOptions = {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: 0.2 // when element is 1/5 in view
    }
    
    function animateValue(element, start, end, duration) {
        let startTimestamp = null;
        const step = (timestamp) => {
            if (!startTimestamp) {
                startTimestamp = timestamp;
            }

            const progress = Math.min((timestamp - startTimestamp) / duration, 1);

            element.innerText = Math.floor(progress * (end - start) + start).toLocaleString();
            
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };

        window.requestAnimationFrame(step);
    }

    const observer = new IntersectionObserver(function(entries, self) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                //console.log('scroll intersecting: ', entry.target);
                entry.target.classList.add("statistics-count-up-animated");

                animateValue(entry.target, 0, Number(entry.target.dataset.count), 2000);
                
                self.unobserve(entry.target);
            }
        });
    }, observerOptions);

    //const observedElements = document.querySelectorAll(':not(.is-intersecting)');
    const observedElements = document.querySelectorAll('.statistics-count-up:not(.statistics-count-up-animated)');
    if (observedElements.length > 0) {
        //console.log('observedElements', observedElements);
        observedElements.forEach(element => {
            observer.observe(element);
        });
    }
}

export default RevealStatistics;
